<template>
  <div class="container-outline">
    <div class="register">
      <div class="title">Register</div>
      <div class="top-squence">
        <head-register :dataSquence="{ id: 5, title: 'kontak' }" />
      </div>
      <div class="content-register">
        <div class="container">
          <p class="sub-title">PIHAK YANG DIHUBUNGI DALAM KEADAAN DARURAT</p>
          <p>Dalam keadaan darurat, pihak yang dapat dihubungi</p>
          <form @submit.prevent="registerKYC">
            <div class="form-group">
              <label for="">Nama Lengkap*</label>
              <input
                type="text"
                maxlength="70"
                class="form-input"
                placeholder="Masukkan nama lengkap kontak darurat"
                v-model="form.fullname"
                required
                @keyup="form.fullname = form.fullname.replace(/[^a-zA-Z\s]/g, '')"
              />
            </div>
            <div class="form-group">
              <label for="">Alamat Rumah*</label>
              <input
                type="text"
                maxlength="80"
                class="form-input"
                placeholder="Alamat lengkap saat ini"
                v-model="form.address"
                required
                @keyup="form.address = form.address.replace(/[^a-zA-Z0-9\s,.-]/g, '')"
              />
            </div>
            <div class="form-group">
              <label>Kode Pos *</label>
              <input
                type="text"
                class="form-input pos-telepon"
                placeholder="Masukkan kodepos"
                v-model="form.postcode"
                @keyup="form.postcode = form.postcode.replace(/[^\d]/g, '')"
                minlength="5"
                maxlength="5"
                required
              />
            </div>
            <div class="form-group">
              <label>No Telepon *</label>
              <input
                type="text"
                class="form-input pos-telepon"
                placeholder="8133370...."
                v-model="form.phonenumber"
                @keyup="form.phonenumber = form.phonenumber.replace(/[^\d]/g, '')"
                required
                minlength="10"
                maxlength="18"
              />
            </div>
            <div class="form-group">
              <label for="">Hubungan dengan anda *</label>
              <input
                type="text"
                maxlength="15"
                class="form-input"
                placeholder="Contoh: saudara kandung"
                v-model="form.relationship"
                required
                @keyup="form.relationship = form.relationship.replace(/[^a-zA-Z\s]/g, '')"
              />
            </div>

            <div class="form-group form-checkbox">
              <input type="checkbox" class="checkbox" required v-model="form.has_confirm_emergency_contact" />
              <label class="label--checkbox">
                Dengan ini saya setuju atas seluruh data KONTAK DARURAT yang saya isi adalah BENAR dan sesuai dengan
                <span id="toggle-btn" class="ketentuan">Peraturan</span> yang berlaku
              </label>
            </div>
            <div class="button">
              <router-link to="/register-datapribadi"><button class="btn-scondary">Sebelumnya</button></router-link>
              <button class="btn-primer" type="submit">
                <div v-show="loading == false">Selanjutnya</div>
                <Loader class="loading" v-show="loading" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../assets/Loading";
import axios from "axios";
import HeadRegister from "./component/HeadRegister.vue";

export default {
  components: {
    Loader,
    HeadRegister,
  },
  data() {
    return {
      form: {
        fullname: "",
        phonenumber: "",
        relationship: "",
        address: "",
        postcode: "",
        has_confirm_emergency_contact: false,
        step: "contact",
      },
      loading: false,
      checkedStatement: "",
      idContact: "",
    };
  },
  computed: {
    customerId() {
      return this.$store.getters.customerData._id;
    },
  },
  mounted() {
    this.$store.dispatch("getCustomer").then((res) => {
      this.idContact = res._id;
      axios.get("/v2/kyc/emergency_contact/" + this.idContact).then((res) => {
        let emergency_contact = res.data.data.emergency_contact;
        this.form.address = emergency_contact.address;
        this.form.has_confirm_emergency_contact = emergency_contact.has_confirm_emergency_contact;
        this.form.fullname = emergency_contact.fullname;
        this.form.phonenumber = emergency_contact.phonenumber;
        this.form.postcode = emergency_contact.postcode;
        this.form.relationship = emergency_contact.relationship;
      });
    });
  },

  methods: {
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["my-modal"].toggle("#toggle-btn");
    },
    registerKYC() {
      this.loading = true;
      axios
        .put("/v2/kyc/emergency_contact/" + this.customerId, this.form)
        .then((res) => {
          this.loading = false;
          let status = res.data.data.status_code;
          if (status == "00") {
            this.$router.push("/register-datapekerjaan");
          } else if (status == "2004") {
            this.isLoading = false;
            this.$notify({
              group: "foo",
              title: "<h5>Data sudah di submit</h5>",
              type: "error",
              duration: 2000,
            });
          } else {
            this.$notify({
              group: "foo",
              title: "<h5>kesalahan sistem</h5>",
              type: "error",
              duration: 2000,
            });
          }
        })
        .catch(() => {
          this.loading = false;
          this.$notify({
            group: "foo",
            title: "<h5>Cek kembali inputan anda</h5>",
            type: "error",
            duration: 2000,
          });
        });
    },
    isNumber(event) {
      const pattern = /[0-9]/;

      let inputChar = String.fromCharCode(event.charCode);
      if (event.keyCode != 8 && !pattern.test(inputChar)) {
        event.preventDefault();
      }
    },
    isAlphabet(event) {
      const pattern = /^[a-zA-Z\s]*$/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    },
    isAlphabetSymbol(event) {
      const pattern = /^[a-zA-Z0-9\s,.-]*$/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    },
  },
};
</script>

<style scoped>
.container-outline {
  width: 70%;
}

.li-active:nth-child(6)::before {
  border: dashed 1px #c59733;
}

.form-checkbox {
  margin-top: 50px;
  font-size: 14px;
  color: #707070;
  display: flex;
}

.label-radio {
  width: 185px;
  cursor: pointer;
}

.outer {
  margin: 10px 25px 10px 15px;
}

.register {
  margin: 46px 0;
}

label {
  font-size: 14px;
  width: 205px;
  display: inline-block;
}

.detail-alamat {
  width: 175px;
  margin: 0 0 0 30px;
}

.form-input {
  width: 73%;
  text-transform: capitalize;
}

select {
  width: 73%;
  height: 45px;
}

.tempat {
  width: 41%;
  margin: 0 25px 0 0;
}

.tanggal {
  width: 25%;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.pos-telepon {
  width: 25%;
}

.jabatan {
  height: 35px;
  width: 10%;
}

.tahun {
  margin: 0 0 0 30px;
}

.identitas {
  width: 20%;
  margin: 0 32px 0 0;
  background-position-x: 88%;
}

.no-identitas {
  width: 50%;
}

.input-button {
  width: 50px;
  height: 50px;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 6px;
  left: -1px;
  border: solid 1px #707070;
  background-color: #6454f0;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
}

.icon-calender {
  font-size: 20px;
  color: white;
}

.content-register {
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
  background: #ffffff;
  border-radius: 5px;
}

.title {
  font-size: 25px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  margin: 0 0 50px;
}

.navigation {
  margin: 0 0 50px;
  font-size: 10px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
}
.container {
  width: 90%;
  padding-top: 45px;
}

.nav-root {
  display: flex;
  justify-content: space-between;
  margin: 0 0 50px;
  position: relative;
}

.list-root {
  list-style: none;
  height: 65px;
  width: 40%;
  padding: 20px 15px;
  text-align: center;
  color: rgba(112, 112, 112, 0.5);
}

.active {
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  border-top: solid 2px #000e22;
  border-right: solid 2px #000e22;
  border-bottom: solid 2px #000e22;
  background-color: #1f354a;
  color: white;
  position: relative;
  text-align: center;
}

.active:first-child {
  border-top-left-radius: 15px;
}

.active:last-child {
  border-top-right-radius: 15px;
  border-bottom-right-radius: 0;
}

.active::before {
  z-index: -1;
  position: absolute;
  content: "";
  display: inline-block;
  width: 50px;
  height: 65px;
  background-color: #1f354a;
  top: -2px;
  left: -41px;
  border: 2px solid #000e22;
}

.active:first-child::before {
  opacity: 0;
}

.button {
  display: flex;
  justify-content: space-between;
  padding: 76px 15px;
}

.sub-title {
  margin: 0 0 73px;
  font-size: 18px;
  font-weight: bold;
}

.arrow {
  margin-left: 10px;
  margin-right: 10px;
  border: solid #6454f0;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 4px;
  transform: rotate(45deg);
  vertical-align: super;
}

.wrap-arrow {
  position: absolute;
  display: inline-block;
  width: 56px;
  height: 48px;
  /* border: solid 1px; */
  right: 50px;
  top: 1px;
  border-radius: 10px;
  text-align: center;
  padding: 15px 9px;
  background: white;
}

@media (min-width: 768px) and (max-width: 1023px) {
  .list-root {
    font-size: 13px;
  }
  .active {
    padding: 10px;
    text-align: center;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .active::before {
    width: 28px;
    left: -25px;
  }

  label,
  .form-input {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .container-outline {
    width: 90%;
  }

  li > span {
    display: none;
  }

  .form-input,
  select,
  .input-button {
    width: 100%;
  }

  label {
    display: block;
  }

  .birtday,
  .kecamatan,
  .input-rt-rw {
    width: 100% !important;
    text-align: left;
  }

  .register {
    margin: 20px 0;
  }

  .title {
    font-size: 18px;
    margin: 0 0 20px;
  }

  .sub-title {
    margin-bottom: 20px;
  }

  .top-squence {
    width: 100%;
    padding: 15px 10px;
  }

  .container {
    width: 100%;
    padding: 25px 20px;
  }

  .identitas,
  .form-ktp-bagi,
  .tanggal-aktif,
  .tempat,
  .kecamatan,
  .input-rt-rw {
    margin: 0 0 10px;
  }

  .detail-alamat,
  .rt-rw {
    margin: 0 0 0.5rem;
  }

  .form-checkbox {
    align-items: flex-start;
  }

  .label--checkbox {
    margin-left: 25px;
  }

  .button {
    display: block;
    width: 100%;
    text-align: center;
  }

  .btn-scondary,
  .btn-primer {
    width: 100%;
  }

  .btn-scondary {
    margin-bottom: 20px;
  }

  .rupiah {
    width: 20%;
    margin-right: 20px;
  }

  .nilai-rupiah {
    width: 73%;
  }
}
</style>
